import { Helmet, HelmetProvider } from "react-helmet-async";
import MyRouter from "routers/index";
// import { ReactLenis } from "lenis/react";
// import "lenis/dist/lenis.css";

// interface LenisInstance {
//   raf: (time: number) => void;
// }

function App() {
  const canonicalUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}${
          (window.location.pathname || "/").replace(/\/+$/, "") || "/"
        }`
      : "";

  return (
    <HelmetProvider>
      <Helmet>
        <title>Devi Plastic</title>
        <meta name="description" content="Devi Plastic" />
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
        {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      </Helmet>

      {/* MAIN APP */}
      <div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
        <MyRouter />
      </div>
    </HelmetProvider>
  );
}

export default App;
